import { IconButton, Tooltip } from "@mui/material";
//import  "../../../../css/Purchase Manager/StockAdjustment/requestForQuatationNw.css"
import React from "react";
import postRibbon from "../../../../../Assets/statusRibbon/post.png";
import draftRibbon from "../../../../../Assets/statusRibbon/draft.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import { companyProfileInfoForUser, viewCompanyProfileInfoAPICall } from "../../../../../API/Settings/Company Settings/companySettingsAPI";
import { useRef } from "react";
import ReactToPrint from "../../../../Shared/print/ReactToPrint";
import { convertDateFormat, today } from "../../../../../Js/Date";
import { purchaseWoSoSingleViewApi } from "./purchaseWPOAPI";
import paidRibbon from "../../../../../Assets/statusRibbon/paid.png"
import { getTemplateAPI } from "../../../SalesNew/SalesOrders/SalesQuotation/salesQuatationAPI";
import Template1 from "../../../SalesNew/SalesOrders/SalesQuotation/Template1";
import Template2 from "../../../SalesNew/SalesOrders/SalesQuotation/Template2";
import { set_Back_button_action } from "../../../../Single Components/listSlice/filterCategorySlice";
import { InvoiceContent } from "../../PrintComponents/printTemplates/common/InvoiceContent";
import { printSection } from "../../PrintComponents/printTemplates/common/enum";

export const PurchaseWOPOsingleView = () => {
  let singleViewId = localStorage.getItem("singleViewById");
  let paymentsPrint = useRef();
  let paymentsPrintNew = useRef();
  const componentRef = useRef();

  //data of selected List
  const singleList = useSelector((state) => state?.purchaseWPOSlice?.rowData);
  const decimalPosition = localStorage.getItem("decimalPosition");
  // company details and info
  const companyProfileData =useSelector(
    (state) => state?.companyProfileSlice?.userValue)
  const template =useSelector((state)=>state?.salesQuatationSlice?.setTemplate)

  const dispatch = useDispatch();

  //initial value
  const formValuesInitialState = {
    status: "",
    companyLogo: "",
    companyName: "",
    companyAddress: "",
    companyContact: "",
    companyTRN: "",

    customerName: "",
    customerAddress: "",
    customerContact: "",
    customerEmail: "",
    trn:"",

    dateN1:"Return Date",
    dateN2:"Invoice Date",

    termsAndCondition:"",

    name: "",
    firstDate: "",
    secondDate: "",
    expiry:"",
    
    address:"Vendor ",
    sequence:"Bill No",
    lpo:"",
    ref:"",
    subtotal: "",
    total: "",
    totalAmount:"",
    payTerm:"",
    label:"PURCHASE W/PO"
  };
  const [formValues, setFormValues] = useState(formValuesInitialState);
  const [tax, setTax] = useState([]);
  const [data, setData] = useState([]);
  const [domain, setDomain] = useState("");



  useEffect(() => {
    setFormValues({
      ...formValues,
      status: singleList?.status,
      companyLogo: companyProfileData?.logo || "",
      companyName: companyProfileData?.companyName || "",
      companyAddress: companyProfileData?.companyAddress || "",
      companyContact: companyProfileData?.contactNumber || "",
      companyTRN: companyProfileData?.companyTRN || "",

      customerName: singleList?.vendorAddress?.vendorName|| "",
      customerAddress: singleList?.vendorAddress?.streetName || "",
      customerContact: singleList?.vendorAddress?.mobileNo || "",
      customerEmail: singleList?.vendorAddress?.email || "",
      trn: singleList?.vendorAddress?.TRN || "",

      termsAndCondition:singleList?.termsAndCondition || "",


      lpo: singleList?.LpoNo ||"",
      ref: singleList?.billRef ||"",      
      subtotal: singleList?.subTotal || "",
      name: singleList?.NAME || "",
      expiry: singleList?.accountingDate|| "",
      secondDate: singleList?.billDate || "",
      totalAmount: singleList?.totalAmount || "",
      total: singleList?.total || "",
      payTerm: singleList?.PAYMENTTERM || "",
    });
    setData(singleList?.productInfo);
    setTax(singleList?.taxDetails);
  }, [singleList, companyProfileData]);

  // api to fetch companyprofile data
  useEffect(() => {
    getTemplateAPI();
    if(singleViewId){
      purchaseWoSoSingleViewApi({_id:singleViewId})
    }
  }, []);

  // 🚀 Ultra-Fast Print Function
  const handleFastPrint = async () => {
    // Check if data is available
    if (!data || data.length === 0) {
      console.error('No purchase W/PO data available to print');
      return;
    }

    try {
      console.log('🚀 Starting Ultra-Fast Print - Creating content programmatically');

      // Create purchase W/PO HTML content programmatically - matching screen view
      const createPurchaseWPOHTML = () => {
        const items = data.map((item, index) => `
          <tr style="background-color: ${index % 2 === 0 ? '#f1f2f5' : 'white'};">
            <td>${index + 1}</td>
            <td>${item.product || ''}</td>
            <td>${item.uomName || ''}</td>
            <td>${item.qty || 0}</td>
            <td>${item.unitPrice || 0}</td>
            <td>${item.discount || 0}</td>
            <td style="display: flex; place-content: center; margin-top: 10px;">
              ${item.taxIdList?.map((r, i) => `
                <p key="${i}" style="margin: 1px;">${r?.taxName || ''}</p>
              `).join('')}
            </td>
            <td>${(item.lineTotal || 0).toFixed(decimalPosition || 2)}</td>
          </tr>
        `).join('');

        return `
          <div style="font-family: Arial, sans-serif; padding: 20px; background-color: white;">
            <!-- Header Section - improved alignment without status ribbon -->
            <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 40px; padding: 20px 0;">
              <!-- Left Side - Company Info -->
              <div style="width: 48%; padding-right: 20px;">
                ${formValues?.companyLogo ? `<img src="${formValues?.companyLogo}" alt=" " style="max-width: 180px; margin-bottom: 15px; display: block;" />` : ''}
                <p style="margin: 8px 0; font-weight: bold; font-size: 14px;">${formValues?.companyName || ''}</p>
                <p style="margin: 6px 0; font-size: 12px; color: #555;">${formValues?.companyAddress || ''}</p>
                <p style="margin: 6px 0; font-size: 12px; color: #555;">${formValues?.companyContact || ''}</p>
                ${formValues?.companyTRN ? `<p style="margin: 6px 0; font-size: 12px; color: #555;">TRN: ${formValues?.companyTRN}</p>` : ''}
                
                <div style="margin-top: 25px; padding-top: 15px; border-top: 1px solid #eaeef9;">
                  <h2 style="margin: 0 0 12px 0; font-size: 14px; color: #333; font-weight: bold;">VENDOR ADDRESS</h2>
                  <p style="margin: 6px 0; font-weight: bold; font-size: 13px;">${formValues?.customerName || ''}</p>
                  <p style="margin: 6px 0; font-size: 12px; color: #555;">${formValues?.customerAddress || ''}</p>
                  <p style="margin: 6px 0; font-size: 12px; color: #555;">${formValues?.customerContact || ''}</p>
                  <p style="margin: 6px 0; font-size: 12px; color: #555;">${formValues?.customerEmail || ''}</p>
                  ${formValues?.trn ? `<p style="margin: 6px 0; font-size: 12px; color: #555;">TRN: ${formValues?.trn}</p>` : ''}
                </div>
              </div>
              
              <!-- Right Side - Purchase W/PO Info -->
              <div style="width: 48%; padding-left: 20px; text-align: right; border-left: 1px solid #eaeef9;">
                <h1 style="margin: 0 0 15px 0; font-size: 28px; color: #333; font-weight: bold;">PURCHASE W/PO</h1>
                <div style="background-color: #f8f9fa; padding: 15px; border-radius: 4px; margin-bottom: 20px;">
                  <p style="margin: 0 0 8px 0; font-size: 12px; color: #666; text-transform: uppercase;">Document Number</p>
                  <p style="margin: 0; font-size: 20px; font-weight: bold; color: #333;">${formValues?.name || ''}</p>
                </div>
                <div style="background-color: #f8f9fa; padding: 15px; border-radius: 4px;">
                  <p style="margin: 0 0 8px 0; font-size: 12px; color: #666; text-transform: uppercase;">Document Date</p>
                  <p style="margin: 0; font-size: 16px; font-weight: bold; color: #333;">${formValues?.expiry || formValues?.firstDate || ''}</p>
                </div>
                ${formValues?.lpo ? `
                  <div style="margin-top: 15px;">
                    <p style="margin: 0 0 5px 0; font-size: 12px; color: #666;">LPO Reference</p>
                    <p style="margin: 0; font-size: 14px; font-weight: bold; color: #333;">${formValues?.lpo}</p>
                  </div>
                ` : ''}
              </div>
            </div>

            <!-- Table Section - matching screen styling -->
            <div style="margin-bottom: 20px;">
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr style="background-color: #eaeef9;">
                    <th style="padding: 10px; text-align: left; border: 1px solid #ddd;">No</th>
                    <th style="padding: 10px; text-align: left; border: 1px solid #ddd;">Product</th>
                    <th style="padding: 10px; text-align: left; border: 1px solid #ddd;">UOM</th>
                    <th style="padding: 10px; text-align: left; border: 1px solid #ddd;">QTY</th>
                    <th style="padding: 10px; text-align: left; border: 1px solid #ddd;">Unit Price</th>
                    <th style="padding: 10px; text-align: left; border: 1px solid #ddd;">Discount</th>
                    <th style="padding: 10px; text-align: left; border: 1px solid #ddd;">Tax</th>
                    <th style="padding: 10px; text-align: left; border: 1px solid #ddd;">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  ${items}
                </tbody>
              </table>
            </div>

            <!-- Total Section - matching screen layout -->
            <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 20px; border-top: 2px solid #eaeef9; padding-top: 15px;">
              <div style="width: 50%;">
                <h1 style="margin: 0; font-size: 18px;">Total</h1>
              </div>
              <div style="width: 50%; text-align: right;">
                <h1 style="margin: 0; font-size: 18px; font-weight: bold;">${formValues.total || '0'}</h1>
              </div>
            </div>
          </div>
        `;
      };

      const purchaseWPOHTML = createPurchaseWPOHTML();
      
      // Create print window with fast mode styles
      const printWindow = window.open('', '_blank', 'width=800,height=600');
      
      if (!printWindow) {
        console.error('Failed to open print window');
        return;
      }

      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>Purchase W/PO - Fast Print</title>
          <style>
            /* Fast Print CSS - Optimized for speed */
            body { 
              margin: 0; 
              padding: 10mm; 
              font-family: Arial, sans-serif;
              font-size: 12px;
              line-height: 1.4;
            }
            table {
              page-break-inside: avoid;
              break-inside: avoid-page;
            }
            tr { 
              page-break-inside: avoid;
            }
            /* Natural pagination - minimal restrictions */
            @media print { 
              body { margin: 0; padding: 10mm; }
              /* Only prevent row breaks, let everything else flow naturally */
              tr { 
                page-break-inside: avoid;
              }
              /* Allow table headers to repeat on new pages */
              thead { 
                display: table-header-group;
              }
            }
          </style>
        </head>
        <body>
          ${purchaseWPOHTML}
          <script>
            window.onload = function() {
              setTimeout(() => {
                window.print();
                window.close();
              }, 500);
            }
          </script>
        </body>
        </html>
      `);

      printWindow.document.close();
      console.log('✅ Ultra-Fast Print initiated successfully');

    } catch (error) {
      console.error('❌ Error in fast print:', error);
    }
  };

  let navigateTo = useNavigate();
  return (
    <div className="main-container" style={{ backgroundColor: "unset", padding: "0" }}>
      <div className="first-div-container"style={{ backgroundColor: "white", justifyContent: "space-between" }}>
        {/* <div className="post-ribbon">
          {formValues?.status === "DRAFT" && <img src={draftRibbon} alt="" />}
          {formValues?.status === "POSTED" && <img src={postRibbon} alt="" />}
          {formValues?.status==="PAID" && <img src={paidRibbon} alt="" />}

        </div> */}
        <div style={{display:"flex",gap:"8px"}}>

        <Tooltip title="Edit">
          <IconButton>
            <i
              class="bi bi-pencil-square edit-icon1"
              onClick={() =>
                navigateTo("/userdashboard/accounts/vendor/purchasewopo/create")
              }
            ></i>
          </IconButton>
        </Tooltip>
        
        <h3>
            <span
             
              style={{ fontSize: "medium", color: "black", cursor: "pointer" }}
              onClick={() =>{
                localStorage.removeItem("singleViewById");
                navigateTo("/userdashboard/accounts/vendor/purchasewopo")
                dispatch(set_Back_button_action({ backButtonClickAction: true }));
              }}
            > Purchase w/po &gt;</span>
         <span  style={{fontSize:"medium",paddingLeft:"8px"}}>{formValues?.name}</span>
       
        </h3>
        </div>
        {/* <ReactToPrint
          trigger={() => (
            <IconButton className="printer-div">
              <i style={{ color: "black" }} class="bi bi-printer"></i>
            </IconButton>
          )}
          content={() => paymentsPrint}
        /> */}
        <div>
       <Tooltip title="Share">
          <IconButton>
            <i class="bi bi-share" style={{ backgroundColor: "#9797e9", color: "white", fontSize: "medium", padding: "8px", borderRadius: "2px" }}></i>
          </IconButton>
        </Tooltip>

        {/* <ReactToPrint
          trigger={() => (
            <IconButton className="printer-div" style={{ padding: "1px" }}>
              <i style={{ color: "white", backgroundColor: " #d787e7", fontSize: "medium", padding: "8px", borderRadius: "2px" }} class="bi bi-printer"></i>
            </IconButton>
          )}
          content={() => paymentsPrintNew}
        /> */}
        <IconButton 
              className="printer-div" 
              style={{ padding: "1px" }}
              onClick={handleFastPrint}
              title="Fast Print"
            >
              <i
                style={{
                  color: "white",
                  backgroundColor: " #d787e7",
                  fontSize: "medium",
                  padding: "8px",
                  borderRadius: "2px",
                }}
                className="bi bi-printer"
              ></i>
            </IconButton>

        <Tooltip title="Download">
          <IconButton>
            <i class="bi bi-arrow-down-circle" style={{ backgroundColor: "rgb(255 118 133 / 69%)", color: "white", fontSize: "medium", padding: "8px", borderRadius: "2px" }}></i>
          </IconButton>
        </Tooltip>
        </div>
      </div>
      {/* <hr className="line" /> */}
      <div style={{ backgroundColor: "white", height: "80vh", marginTop: "4px", position: "relative" }}>
      <div className="second-main-container">
      <div className="post-ribbon"style={{ right: "0px", top: "0px" }}>
          {formValues?.status === "DRAFT" && <img src={draftRibbon} alt="" />}
          {formValues?.status === "POSTED" && <img src={postRibbon} alt="" />}
          {formValues?.status==="PAID" && <img src={paidRibbon} alt="" />}

        </div>
        <div className="left-side-div">
          <img src={formValues?.companyLogo} alt=" " />
          <p>{formValues?.companyName}</p>
          <p>{formValues?.companyAddress}</p>
          <p>{formValues?.companyContact}</p>

          <h1 className="vendor-head">Vendor Address</h1>
          <p>{formValues?.customerName}</p>
          <p>{formValues?.customerAddress}</p>
          <p>{formValues?. customerContact}</p>
          <p>{formValues?.customerEmail}</p>
          {/* <p>--</p>
          <p>--</p> */}
        </div>
        <div className="right-side-div">
          <h1>Purchase W/PO </h1>
          <p>{formValues?.name}</p>
          <div className="date-div">
            <p>
              <span class="date-container-single">Date:</span>
              {formValues?.expiry}
            </p>
          </div>
        </div>
      </div>

      <div className="Table-container">
        <div className="Table-data">
          <table>
            <thead>
              <tr style={{ backgroundColor: "#eaeef9" }}>
                <th>No</th>
                <th>Product</th>
                <th>UOM</th>
                <th>QTY</th>
                <th>Unit Price</th>
                <th>Discount</th>
                <th>Tax</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#f1f2f5" : "white",
                  }}
                >
                  <td>{index + 1}</td>
                  <td>{item.product}</td>
                  <td>{item.uomName}</td>
                  <td>{item.qty}</td>
                  <td>{item.unitPrice}</td>
                  <td>{item.discount}</td>
                  <td
                    style={{
                      display: "flex",
                      placeContent: "center",
                      marginTop: "10px",
                    }}
                  >
                    {item.taxIdList?.map((r, i) => (
                      <p key={i}  style={{ margin: "1px" }}>
                        {r?.taxName}
                      </p>
                    ))}
                  </td>
                  <td>{item.lineTotal?.toFixed(decimalPosition)}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="last-total-div">
            <div className="sub-total">
              <h1>Total</h1>
            </div>
            <div className="sub-total-amount">
              <h1>{formValues.total}</h1>
            </div>
          </div>
        </div>
      </div>
      </div>

      {/* payments print view */}
      <div style={{ display: "none" }}>
        <div ref={(el) => (paymentsPrint = el)}>
          <div className="print-view-top-container">
            <div
              className="print-view-top-left-container"
              style={{ width: "25%" }}
            >
              <p></p>
              <p></p>
            </div>
            <div
              className="print-view-top-middle-container"
              style={{ width: "50%" }}
            >

              <p>Purchase W/PO</p>
            </div>

            <div
              className="print-view-top-right-container"
              style={{ width: "25%" }}
            >
              <p>{convertDateFormat(today)}</p>
              <p>{""}</p>
            </div>
          </div>

          <div className="second-main-container">
            <div className="left-side-div">
              <img
                src={formValues?.companyLogo}
                alt={formValues?.companyName}
              />
              <p>{formValues?.companyAddress}</p>
              <p>{formValues?.companyContact}</p>

              <h1 className="vendor-head">Vendor Address</h1>
              <p>{formValues?.vendorName}</p>
            </div>
            <div className="right-side-div">
              <h1>Purchase W/PO </h1>
              <p>{formValues?.name}</p>
              <div className="date-div">
                <p>
                  <span class="date-container-single">Date:</span>
                  {formValues?.Date}
                </p>
              </div>
            </div>
          </div>

          <div className="Table-container" style={{ padding: "0px 35px" }}>
            <div className="Table-datas">
              <table style={{ overflow: "none" }}>
                <thead>
                  <tr style={{ backgroundColor: "#eaeef9" }}>
                    <th>No</th>
                    <th>Product</th>
                    <th>Account</th>
                    <th>UOM</th>
                    <th>QTY</th>
                    <th>Unit Price</th>
                    <th>Discount</th>
                    <th>Tax</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: index % 2 === 0 ? "#f1f2f5" : "white",
                      }}
                    >
                      <td>{index + 1}</td>
                      <td>{item.product}</td>
                      <td>{item.account}</td>
                      <td>{item.uomName}</td>
                      <td>{item.qty}</td>
                      <td>{item.unitPrice}</td>
                      <td>{item.discount}</td>
                      <td
                        style={{
                          display: "flex",
                          placeContent: "center",
                          marginTop: "10px",
                        }}
                      >
                        {item.taxIdList?.map((r, i) => (
                          <p key={i} className="tax" style={{ margin: "1px" }}>
                            {r?.taxName}
                          </p>
                        ))}
                      </td>
                      <td>{item.cost}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="last-total-div">
                <div className="sub-total">
                  <h1>Total</h1>
                </div>
                <div className="sub-total-amount">
                  <h1>{formValues.total}</h1>
                </div>
              </div>
            </div>
          </div>
          <div className="terms">
            <h1>Terms & Conditions</h1>
            <hr className="lines" />
          </div>
        </div>
      </div>
      {/* <div style={{ display: "none" }}>
  <div ref={(el) => (paymentsPrintNew = el)}>
    {template?.templateModel === 'template1' ? (
      <Template1 data={data} formValues={formValues} tax={tax} />
    ) : (
      <Template2 data={data} formValues={formValues} tax={tax}/>
    )}
  </div>
</div> */}
<div style={{ display: "none" }}>
        <div ref={(el) => (paymentsPrintNew = el)}>
          <InvoiceContent
            invoiceDetails={{ ...formValues, printSection: printSection.purchaseWPO }}
            ref={componentRef}
            printData={data}
            taxDetails={tax}
            qrData={domain}
          />
        </div>
      </div>
    </div>
  );
};
